import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Icon, Link } from '~/components';
import { apps } from '~/utils/mocks/apps';
import * as S from './styles';

export default function TabBar({ isOpen }) {
  const location = useLocation();
  const { user } = useSelector(state => state.user);
  const { url } = useRouteMatch();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const { t } = useTranslation();

  const isCurrentPath = pathString => {
    return location.pathname.includes(pathString);
  };

  const navigateTo = route => {
    return isCurrentPath(route)
      ? `${url}/previous`
      : `${url}/previous/${route}`;
  };

  return (
    <S.NavBar>
      <S.NavBarTitle>
        <S.Subtitle>{t('accessAppInformation')}</S.Subtitle>
        <S.Title>{t('apps')}</S.Title>
      </S.NavBarTitle>
      <S.Grow />
      {apps.map(app => (
        <S.NavBarOption
          key={app.route}
          isActive={isCurrentPath(app.route)}
          onClick={() => {}}
          competition={match?.competitionId}
        >
          <Link to={navigateTo(app.route)}>
            <S.TabLabel>
              {t(app.name)} {user && user.laliga && `/ ${t(app.altLoggedname)}`}
            </S.TabLabel>
            <Icon
              name={isCurrentPath(app.route) ? 'chevronDown' : 'chevronUp'}
              size={15}
              color={isCurrentPath(app.route) ? 'dark' : 'light'}
            />
          </Link>
        </S.NavBarOption>
      ))}
      <S.CloseNavBarOptionContainer shouldShow={isOpen}>
        <S.CloseLink to={`${url}/previous`}>
          <Icon name="close" size={15} color="white" />
        </S.CloseLink>
      </S.CloseNavBarOptionContainer>
    </S.NavBar>
  );
}

TabBar.propTypes = {
  isOpen: PropTypes.bool,
};

TabBar.defaultProps = {
  isOpen: false,
};
